import { CURRENCY_MAP, DEFAULT_CURRENCY } from './constants';

export const getCurrency = (region) => {
	return CURRENCY_MAP[region] || DEFAULT_CURRENCY; // Default to 'EUR' if not set
};

export const getDateFormat = (locale) => {
	const dateFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
	const dateFormatParts = new Intl.DateTimeFormat(locale, dateFormatOptions).formatToParts(
		new Date()
	);

	return dateFormatParts
		.map((part) => {
			if (part.type === 'literal') return part.value.trim();
			if (part.type === 'day') return 'dd';
			if (part.type === 'month') return 'MM';
			if (part.type === 'year') return 'yyyy';
		})
		.join('');
};

export const getCultureInfo = (locale) => {
	let [language, region] =
		typeof locale === 'string' && locale.includes('-')
			? locale.split('-')
			: DEFAULT_CULTURE.split('-');

	// additional check if locale is not in the format 'xx-XX'
	if (!language || !region) {
		[language, region] = DEFAULT_CULTURE.split('-');
	}

	const currency = getCurrency(region);
	const dateFormat = getDateFormat(`${language}-${region}`);

	return {
		CULTURE_INFO: region,
		CULTURE_LANG: language,
		CULTURE_CURRENCY: currency,
		CULTURE_CURRENCY_ALTERNATIVE: currency,
		CULTURE_DATE_FORMAT: dateFormat
	};
};
